import React, { useEffect, useState } from "react";
import { useAppDispatch, useAppSelector } from "../../../../app/hooks";
import LoadingOverlay from "react-loading-overlay-ts";

import {
  changeActiveComponent,
  getBillingCsvData,
  getBillingData,
  selectActiveDashboardComponent,
  selectBillingInfo,
  selectCurrentFilteredBillingRequest,
  selectLoadingBilling,
  selectLoadingBillingDataCsv,
} from "../DashboardSlice";
import { ClipLoader } from "react-spinners";
import { ReactComponent as BarIcon } from "../../../../Assets/common/images/barGraphIcon.svg";
import { ReactComponent as AreaIcon } from "../../../../Assets/common/images/stackArea.svg";
import { convertDateStandard } from "../../../../helpers/utils";
import {
  EchartsGraphStackArea,
  EchartsGraphStackBar,
  TableComponent,
} from "../../facturacion/facturacionComponents/components";
import { KpiConsumption } from "./components/KpiConsumption";

export const BillingConsumption = () => {
  const dispatch = useAppDispatch();
  const currentFilteredBillingRequest = useAppSelector(
    selectCurrentFilteredBillingRequest
  );
  const billingData = useAppSelector(selectBillingInfo);
  const billingInfoLoading = useAppSelector(selectLoadingBilling);
  const billingInfoCsvLoading = useAppSelector(selectLoadingBillingDataCsv);
  const [changeGraph, setChangeGraph] = useState<"stackBar" | "stackArea">(
    "stackBar"
  );
  const activeComponent = useAppSelector(selectActiveDashboardComponent);
  const { startDate, endDate } = currentFilteredBillingRequest;
  const { diffTimeNew } = convertDateStandard(startDate, endDate) || {};

  useEffect(() => {
    dispatch(changeActiveComponent("Billing"));
    dispatch(getBillingData());
  }, [
    currentFilteredBillingRequest.endDate,
    currentFilteredBillingRequest.startDate,
  ]);
  useEffect(() => {
    if (activeComponent !== "Billing") {
      dispatch(changeActiveComponent("Billing"));
    }
  }, [activeComponent]);
  return (
    <LoadingOverlay
      active={billingInfoLoading === "pending"}
      spinner={<ClipLoader color="white" size={"150px"} />}
    >
      <div className="h-100 p-3 overflow-auto">
        <div className="flex-col conteiner-indicators-card">
          <div className="primary-color">
            <p
              className="text-bold text-x-large"
              style={{ margin: "10px", textAlign: "center" }}
            >
              Servicios Consumidos
            </p>
            <div className="conteiner-indicators">
              <div className="kpi-container">
                {billingData &&
                Object.keys(billingData.serviceCount || {}).length > 0 ? (
                  <KpiConsumption data={billingData.serviceCount} />
                ) : (
                  <p className="kpi-empty">No hay información disponible</p>
                )}
              </div>
            </div>
          </div>
        </div>
        <div className="conteiner-indicators-card mt-3">
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <div>
              <button
                className="button-style"
                style={{
                  backgroundColor:
                    changeGraph === "stackBar"
                      ? "rgba(0,0,0,0.2)"
                      : "rgba(0,0,0,0.0)",
                }}
                onClick={() => {
                  setChangeGraph("stackBar");
                }}
              >
                <BarIcon />{" "}
              </button>
              <button
                className="button-style"
                style={{
                  backgroundColor:
                    changeGraph === "stackArea"
                      ? "rgba(0,0,0,0.2)"
                      : "rgba(0,0,0,0.0)",
                }}
                onClick={() => {
                  setChangeGraph("stackArea");
                }}
              >
                <AreaIcon />
              </button>
            </div>
          </div>
          {changeGraph === "stackBar" && (
            <>
              {billingData ? (
                <div
                  style={{
                    backgroundColor: "rgb(0,0,0,0.2)",
                    borderRadius: "8px",
                  }}
                >
                  <EchartsGraphStackBar
                    startDate={startDate ? new Date(startDate) : new Date()}
                    endDate={endDate ? new Date(endDate) : new Date()}
                    clientDateCount={billingData.servicesDateCount || {}}
                    rangeInDays={diffTimeNew ?? 0}
                    title={"Comportamiento consumo de servicios"}
                    isCount
                  />
                </div>
              ) : (
                <div
                  style={{
                    backgroundColor: "rgb(0,0,0,0.2)",
                    borderRadius: "8px",
                  }}
                >
                  <h3 style={{ color: "#fff", marginBottom: "20px" }}>
                    No hay información disponible
                  </h3>
                </div>
              )}
            </>
          )}

          {changeGraph === "stackArea" && (
            <>
              {billingData ? (
                <div
                  style={{
                    backgroundColor: "rgb(0,0,0,0.2)",
                    borderRadius: "8px",
                  }}
                >
                  <EchartsGraphStackArea
                    startDate={startDate ? new Date(startDate) : new Date()}
                    endDate={endDate ? new Date(endDate) : new Date()}
                    clientDateCount={billingData.servicesDateCount || {}}
                    rangeInDays={diffTimeNew ?? 0}
                    title={"Comportamiento consumo de servicios"}
                    isCount
                  />
                </div>
              ) : (
                <div
                  style={{
                    backgroundColor: "rgb(0,0,0,0.2)",
                    borderRadius: "8px",
                  }}
                >
                  <h3 style={{ color: "#fff", marginBottom: "20px" }}>
                    No hay informacion disponible
                  </h3>
                </div>
              )}
            </>
          )}
        </div>
        <div className="mt-3 conteiner-indicators-card p-2 overflow-auto">
          {billingData ? (
            <TableComponent
              data={billingData.servicesDateCount || {}}
              title="Cliente"
              inputLoader={billingInfoCsvLoading}
              downloadReport={() => {
                dispatch(getBillingCsvData());
              }}
              rangeInDays={diffTimeNew ?? 0}
              isCount
            />
          ) : (
            <div
              style={{
                backgroundColor: "rgb(0,0,0,0.2)",
                borderRadius: "8px",
              }}
            >
              <h3 style={{ color: "#fff", marginBottom: "20px" }}>
                No hay informacion disponible
              </h3>
            </div>
          )}
        </div>
      </div>
    </LoadingOverlay>
  );
};
